export const FeatureDefinitions = {
  pipelineTemplates: {
    label: 'app.pricing.plan_picker_2024.features.pipeline_templates.label',
    tooltip: 'app.pricing.plan_picker_2024.features.pipeline_templates.tooltip',
  },
  pipelineAutomations: {
    label: 'app.pricing.plan_picker_2024.features.pipeline_automations.label',
    tooltip: 'app.pricing.plan_picker_2024.features.pipeline_automations.tooltip',
  },
  automatedEmails: {
    label: 'app.pricing.plan_picker_2024.features.automated_emails.label',
    tooltip: 'app.pricing.plan_picker_2024.features.automated_emails.tooltip',
  },
  webhooks: {
    label: 'app.pricing.plan_picker_2024.features.webhooks.label',
    tooltip: 'app.pricing.plan_picker_2024.features.webhooks.tooltip',
  },
  profilePrint: {
    label: 'app.pricing.plan_picker_2024.features.profile_print.label',
    tooltip: 'app.pricing.plan_picker_2024.features.profile_print.tooltip',
  },
  roleBasedAccess: {
    label: 'app.pricing.plan_picker_2024.features.role_based_access.label',
    tooltip: 'app.pricing.plan_picker_2024.features.role_based_access.tooltip',
  },
  visibility: {
    label: 'app.pricing.plan_picker_2024.features.visibility.label',
    tooltip: 'app.pricing.plan_picker_2024.features.visibility.tooltip',
  },
  eeo: {
    label: 'app.pricing.plan_picker_2024.features.eeo_compliance.label',
    tooltip: 'app.pricing.plan_picker_2024.features.eeo_compliance.tooltip',
  },
  fairEvaluations: {
    label: 'app.pricing.plan_picker_2024.features.fair_evaluations.label',
    tooltip: 'app.pricing.plan_picker_2024.features.fair_evaluations.tooltip',
  },
  unlimitedJobs: {
    label: 'app.pricing.plan_picker_2024.features.unlimited_jobs.label',
  },
  careersHub: {
    label: 'app.pricing.plan_picker_2024.features.careers_hub_multi_page.label',
    tooltip: 'app.pricing.plan_picker_2024.features.careers_hub_multi_page.tooltip',
  },
  referrals: {
    label: 'app.pricing.plan_picker_2024.features.referrals_hub.label',
    tooltip: 'app.pricing.plan_picker_2024.features.referrals_hub.tooltip',
  },
  eventScheduler: {
    label: 'app.pricing.plan_picker_2024.features.event_scheduler.label',
    tooltip: 'app.pricing.plan_picker_2024.features.event_scheduler.tooltip',
  },
  questionnaires: {
    label: 'app.pricing.plan_picker_2024.features.questionnaires.label',
    tooltip: 'app.pricing.plan_picker_2024.features.questionnaires.tooltip',
  },
  knockoutQuestions: {
    label: 'app.pricing.plan_picker_2024.features.knockout_questions.label',
    tooltip: 'app.pricing.plan_picker_2024.features.knockout_questions.tooltip',
  },
  multiLocations: {
    label: 'app.pricing.plan_picker_2024.features.multi_locations.label',
    tooltip: 'app.pricing.plan_picker_2024.features.multi_locations.tooltip',
  },
  multiLanguages: {
    label: 'app.pricing.plan_picker_2024.features.multi_languages.label',
    tooltip: 'app.pricing.plan_picker_2024.features.multi_languages.tooltip',
  },
  customReporting: {
    label: 'app.pricing.plan_picker_2024.features.custom_reporting_and_analytics.label',
    tooltip: 'app.pricing.plan_picker_2024.features.custom_reporting_and_analytics.tooltip',
  },
};

// Bring back when video is ready
// export const ScaleToStartVideoId = 'app.pricing.plan_picker_2024.migration.scale_start_yt_id';
